const STORAGE_KEY = 'read_notice_ids';

// 최신 공지 ID 목록 — 새 공지 추가 시 여기에 ID 추가
export const LATEST_NOTICE_IDS = [2];

function getReadNoticeIds() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

function setReadNoticeIds(ids) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // localStorage quota 초과 시 무시
  }
}

export default {
  data() {
    return {
      readNoticeIds: []
    };
  },
  created() {
    this.readNoticeIds = getReadNoticeIds();
  },
  methods: {
    isNoticeRead(noticeId) {
      return this.readNoticeIds.includes(noticeId);
    },
    markNoticeIdAsRead(noticeId) {
      if (!this.readNoticeIds.includes(noticeId)) {
        this.readNoticeIds.push(noticeId);
        setReadNoticeIds(this.readNoticeIds);
      }
    },
    hasUnreadNotices(noticeList) {
      return noticeList.some(n => !this.readNoticeIds.includes(n.notice_id));
    }
  }
};

export function clearExceptIsRead(clear_all = false) {
  const readNoticeIdsValue = localStorage.getItem(STORAGE_KEY);
  const shouldReload = parseInt(localStorage.getItem('should_reload'), 10) || 0;
  const ert_version = localStorage.getItem('ert_version');

  if (clear_all) {
    localStorage.clear();
    if (readNoticeIdsValue !== null) {
      localStorage.setItem(STORAGE_KEY, readNoticeIdsValue);
    }
    if (shouldReload === 0) {
      localStorage.setItem('should_reload', 1);
      window.location.reload();
    } else {
      localStorage.setItem('should_reload', 0);
    }
  } else {
    if (readNoticeIdsValue !== null) {
      localStorage.setItem(STORAGE_KEY, readNoticeIdsValue);
    }
  }

  if (ert_version !== null) {
    localStorage.setItem('ert_version', ert_version);
  }
}
